/**
 * A summary of a rota.
 */
export class RotaSummary {
  date: string;

  /**
   * @param date the Monday from which a rota starts.
   */
  constructor(date: string) {
    this.date = date;
  }
}
